export class ToastModel {
  Icon: string;
  Title: string;
  MessageHtml: string;
  Timestamp: number;
  Duration: number;
  Percentage: number;
}
